import { createCategoryLandingDefaultFormFields } from '../common/formFields'
import { getGenericCodeTemplatePreset } from '../common/genericPresets'
import { getCategoryLandingHeroImage } from '../common/heroImages'

export function getInsuranceRemodelingPreset(presetKey = 'default') {
  if (presetKey === 'lead-gen-fullbleed') {
    return getGenericCodeTemplatePreset('INSURANCE_REMODELING', 'lead-gen-fullbleed')
  }
  if (presetKey === 'basic-template-4' || presetKey === 'basic-template-5') {
    return getGenericCodeTemplatePreset('INSURANCE_REMODELING', presetKey)
  }
  if (presetKey === 'clean-form') {
    return {
      key: 'insurance-remodeling-clean-form',
      category: 'INSURANCE_REMODELING',
      name: '보험리모델링 기본 템플릿 2 - 간편 문의형',
      heroTitle: '유지할 보장과 조정할 보장을 기준별로 구분합니다',
      heroSubtitle: '현재 가입 구조를 바탕으로 보장 공백, 중복 담보, 보험료 지속 가능성을 함께 점검합니다.',
      heroImageFileId: getCategoryLandingHeroImage('INSURANCE_REMODELING'),
      formTitle: '보험 점검 상담 신청',
      contentSections: [
        {
          type: 'icon-grid',
          title: '',
          columns: 3,
          items: [
            { icon: '🧾', title: '가입 구조 확인', description: '현재 보험의 목적과 보장 범위를 먼저 정리합니다.' },
            { icon: '✂️', title: '중복·과다 구분', description: '반복되는 담보와 실제 필요 항목을 구분합니다.' },
            { icon: '🛠️', title: '유지·조정 방향', description: '무조건 변경이 아닌 유지할 항목까지 함께 판단합니다.' },
          ],
        },
      ],
      formFields: createCategoryLandingDefaultFormFields(),
      surveyCustomFields: [
        { id: 'q1', type: 'select', label: '리모델링 목적은?', required: false, options: ['보험료 절감', '보장 강화', '중복 제거', '상황 변화 대응'] },
      ],
      customConfig: {
        templateStyle: 'clean-form',
        heroBackgroundColor: '#f7fff4',
        heroTextColor: '#14532d',
        heroSubtitleColor: '#16a34a',
        formBorderColor: '#16a34a',
        formBorderWidth: 3,
      },
    }
  }

  if (presetKey === 'hanwha-sections') {
    return {
      key: 'insurance-remodeling-hanwha-sections',
      category: 'INSURANCE_REMODELING',
      name: '보험리모델링 기본 템플릿 3 - 설명형',
      heroTitle: '유지할 것과 줄일 것을 한 번에 점검하는 보험 리모델링',
      heroSubtitle: '가족 구성, 소득 변화, 보험료 부담을 기준으로 유지·조정·보완 포인트를 구분합니다.',
      heroImageFileId: getCategoryLandingHeroImage('INSURANCE_REMODELING'),
      formTitle: '리모델링 진단 신청',
      contentSections: [
        {
          type: 'icon-grid',
          title: '',
          columns: 3,
          items: [
            { icon: '🔎', title: '현재 상태 진단', description: '가입 목적과 현재 생활 변화가 맞는지 확인합니다.' },
            { icon: '🧩', title: '부족·중복 정리', description: '보완할 항목과 조정할 항목을 구분합니다.' },
            { icon: '💬', title: '상담 방향 안내', description: '점검 결과를 기준으로 다음 선택지를 설명합니다.' },
          ],
        },
        {
          type: 'process-steps',
          title: '리모델링 진행 방식',
          steps: [
            { number: 1, icon: '📝', title: '현재 고민 접수', description: '보험료 부담, 보장 부족 등 우선 고민을 확인합니다.' },
            { number: 2, icon: '📊', title: '유지·조정 구분', description: '가입 구조를 보며 유지할 항목과 조정할 항목을 나눕니다.' },
            { number: 3, icon: '🛠️', title: '보완 방향 안내', description: '필요한 경우 보완 방향과 유의사항을 안내합니다.' },
          ],
        },
      ],
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: [
        { id: 'q1', type: 'select', label: '리모델링 목적은?', required: false, options: ['보험료 절감', '보장 강화', '중복 제거', '상황 변화 대응'] },
        { id: 'q2', type: 'textarea', label: '현재 가장 고민되는 점은?', required: false, placeholder: '예: 보험료 부담, 보장 부족' },
      ],
      customConfig: {
        templateStyle: 'hanwha-sections',
        heroBackgroundColor: '#f0fdf4',
        heroTextColor: '#14532d',
        heroSubtitleColor: '#16a34a',
        formBorderColor: '#16a34a',
        formBorderWidth: 3,
        highlightsBackgroundColor: '#f8fafc',
        recommendedTitle: '추천상품',
      },
    }
  }

  return {
    key: 'insurance-remodeling-default',
    category: 'INSURANCE_REMODELING',
    name: '보험리모델링 기본 템플릿 1 - 일반형',
    heroTitle: '유지할 보장과 조정할 보장을 기준별로 구분합니다',
    heroSubtitle: '현재 가입 구조를 바탕으로 보장 공백, 중복 담보, 보험료 지속 가능성을 함께 점검합니다.',
    heroImageFileId: getCategoryLandingHeroImage('INSURANCE_REMODELING'),
    formTitle: '보험 점검 상담 신청',
    contentSections: [
      {
        type: 'text',
        title: '이런 고민이 있다면 점검이 필요합니다',
        content: '보험료 부담이 커졌거나, 가족 구성·소득·건강 상태가 달라졌다면 기존 보험 구조가 지금도 적절한지 확인할 필요가 있습니다. 리모델링은 무조건 바꾸는 과정이 아니라 유지할 보장과 조정할 보장을 구분하는 상담입니다.',
      },
      {
        type: 'benefit-cards',
        title: '리모델링 핵심 포인트',
        items: [
          { icon: '✅', title: '보험료 지속 가능성', description: '현재 납입 구조가 오래 유지 가능한지 살펴봅니다.' },
          { icon: '✅', title: '보장 재배치', description: '부족하거나 중복된 부분을 구분합니다.' },
          { icon: '✅', title: '상황 변화 반영', description: '가족 구성과 소득 변화에 맞는 방향을 설명합니다.' },
        ],
      },
    ],
    formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
    surveyCustomFields: [
      { id: 'q1', type: 'select', label: '리모델링 목적은?', required: false, options: ['보험료 절감', '보장 강화', '중복 제거', '상황 변화 대응'] },
      { id: 'q2', type: 'textarea', label: '현재 가장 고민되는 점은?', required: false, placeholder: '예: 보험료 부담, 보장 부족' },
    ],
    customConfig: {
      templateStyle: 'default',
      heroBackgroundColor: '#f8fafc',
      heroTextColor: '#0f172a',
      heroSubtitleColor: '#475569',
    },
  }
}
